import { render } from "./offerings-edit-modal.vue?vue&type=template&id=08035375&ts=true"
import script from "./offerings-edit-modal.vue?vue&type=script&lang=ts"
export * from "./offerings-edit-modal.vue?vue&type=script&lang=ts"

import "./offerings-edit-modal.vue?vue&type=style&index=0&id=08035375&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__